import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";
import { EntProcessingCompanies } from "../../../models/organic/processingCompanies";
import { EntProcessingCompaniesFilter } from "../../../models/filters/organic/processingCompany";

export const processingCompaniesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getProcessingCompaniesList: builder.query<ResponseDataGet<EntProcessingCompanies>, EntProcessingCompaniesFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.processingCompaniesadmin }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getProcessingCompaniesById: builder.query<ResponseDataGet<EntProcessingCompanies>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.processingCompaniesadmin }/${ id }`,
		method: "GET",
	  }),
	}),

	deleteProcessingCompanies: builder.mutation<ResponseDataGet<EntProcessingCompanies>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.processingCompaniesadmin }/${ id }`,
		method: "DELETE",
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useDeleteProcessingCompaniesMutation,
  useLazyGetProcessingCompaniesListQuery
} = processingCompaniesApi;
